import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    ref: "myEcharts",
    style: _normalizeStyle({
      height: _ctx.height,
      width: _ctx.width
    })
  }, null, 4);
}